module.exports = __webpack_public_path__ + "media/captain_bamboo.d4b5c4be.webm";